(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fazendas-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Carrossel
    const carousels = document.querySelectorAll('.fazendas-carousel');
    
    carousels.forEach(carousel => {
      const container = carousel.closest('.fazendas-carousel-container');
      if (!container) return;
      
      const sectionId = container.id.replace('carousel-', '');
      const prevBtn = document.querySelector(`[data-carousel-prev="${sectionId}"]`);
      const nextBtn = document.querySelector(`[data-carousel-next="${sectionId}"]`);
      
      if (!prevBtn || !nextBtn) return;
      
      let currentIndex = 0;
      const cards = carousel.querySelectorAll('.fazenda-card');
      const totalCards = cards.length;
      
      if (totalCards === 0) return;
      
      function getCardWidth() {
        return cards[0].offsetWidth;
      }
      
      const gap = 20;
      
      function updateCarousel() {
        const cardWidth = getCardWidth();
        const offset = currentIndex * (cardWidth + gap);
        carousel.style.transform = `translateX(-${offset}px)`;
      }
      
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });
      
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const cardsPerView = window.innerWidth > 1024 ? 3 : window.innerWidth > 768 ? 2 : 1;
        if (currentIndex < totalCards - cardsPerView) {
          currentIndex++;
          updateCarousel();
        }
      });
      
      window.addEventListener('resize', () => {
        currentIndex = 0;
        updateCarousel();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
